import React from 'react';

interface ConfirmModalProps {
    show: boolean;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ show, message, onConfirm, onCancel }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-5 rounded-md shadow-lg w-96">
                <div className="text-center text-lg font-medium text-gray-900">{message}</div>
                <div className="mt-4 flex justify-center space-x-4">
                    <button
                        onClick={onConfirm}
                        className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded-md"
                    >
                        Confirm
                    </button>
                    <button
                        onClick={onCancel}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded-md"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
